import { useCallback as V } from "react";
import { getPrefersReducedMotion as p } from "./use-prefers-reduced-motion.js";
const F = (e, r, { leftInsetRef: o, rightInsetRef: i } = {}) => ({ scrollIntoView: V(
  (h) => {
    var g, a, d;
    const l = (g = e.current) == null ? void 0 : g[h], c = r.current;
    if (!l || !c)
      return;
    const n = l.getBoundingClientRect(), t = c.getBoundingClientRect(), s = (a = o == null ? void 0 : o.current) == null ? void 0 : a.getBoundingClientRect(), u = (d = i == null ? void 0 : i.current) == null ? void 0 : d.getBoundingClientRect(), m = s ? Math.max(0, s.right - t.left) : 0, b = u ? Math.max(0, t.right - u.left) : 0, w = t.left + m, B = t.right - b;
    if (n.left >= w && n.right <= B)
      return;
    const C = n.left + n.width / 2 - (t.left + t.width / 2);
    c.scrollBy({ left: C, behavior: p() ? "auto" : "smooth" });
  },
  [e, r, o, i]
) });
export {
  F as useHorizontalScrollIntoView
};
